const SET_SHOWNOTIFICATIONS = (state, payload) => {
  state.showNotifications = payload
}

const SET_USER_NOTIFICATIONS = (state, payload) => {
  payload.forEach(e => {
    e.media = JSON.parse(e.media)
    e.links = JSON.parse(e.links)
  })
  state.notificationData = payload
}

const UPDATE_USER_NOTIFICATIONS = (state, payload) => {
  let notification = state.notificationData.find(f => f.assigneeId === payload.row.assigneeId)
  if (notification) {
    notification.acknowledged = payload.acknowledged
  }
}

const DISMISSACTIVATE_USER_NOTIFICATIONS = (state, payload) => {
  let notification = state.notificationData.find(f => f.assigneeId === payload.row.assigneeId)
  if (notification) {
    notification.deleted = payload.condition
  }
}

export default {
  SET_SHOWNOTIFICATIONS,
  SET_USER_NOTIFICATIONS,
  UPDATE_USER_NOTIFICATIONS,
  DISMISSACTIVATE_USER_NOTIFICATIONS
}
